<div mat-dialog-title class="flex">
  <h2>{{ title }}</h2>
  <app-close-button></app-close-button>
</div>

<mat-dialog-content>
  <form #f="ngForm" [formGroup]="form" novalidate (ngSubmit)="f.form.valid && save()">
    <div class="row">
      <mat-form-field>
          <input matInput placeholder="Question" formControlName="question" required>
      </mat-form-field>
    </div>

    <div class="form-group answers" formArrayName="answers">
      <div class="answers-header">
        <label>Answers:</label>
        <mdb-icon fas icon="plus-circle" class="text-info icon-plus" (click)="addAnswer()"></mdb-icon>
      </div>

      <div class="answer-row" *ngFor="let answer of answers.controls; index as i; first as first; last as last">
        <mat-form-field>
          <input #answerInput matInput placeholder="Answer {{letterArray[i]}}" formControlName="{{i}}" required (keydown.enter)="onAnswerKeyEnter($event, i)">
        </mat-form-field>

        <div class="actions">
          <mdb-icon fas icon="arrow-circle-up" class="text-info icon-up" (click)="moveAnswerUp(i)" [class.disabled]="first"></mdb-icon>
          <mdb-icon fas icon="arrow-circle-down" class="text-info icon-down" (click)="moveAnswerDown(i)" [class.disabled]="last"></mdb-icon>
          <mdb-icon fas icon="plus-circle" class="text-info icon-plus" (click)="addAnswer(i)"></mdb-icon>
          <mdb-icon fas icon="minus-circle" class="text-danger icon-minus" (click)="removeAnswer(i)"></mdb-icon>
        </div>
      </div>

      <mat-error *ngIf="f.submitted && answers?.hasError('minLength')">At least 2 answers required.</mat-error>
      <mat-error *ngIf="f.submitted && answers?.hasError('maxLength')">At most {{letterArray.length}} answers allowed.</mat-error>
    </div>

    <div class="row">
      <mat-form-field>
          <input matInput placeholder="Correct Answer" formControlName="correctAnswer" required>
          <mat-error *ngIf="f.submitted && correctAnswer?.hasError('invalidLetter')">No such answer found. <span *ngIf="answers.length > 1">Select one from {{letterArray[0]}} to {{letterArray[answers.length - 1]}}.</span></mat-error>
      </mat-form-field>
    </div>

    <div class="row">
      <mat-form-field>
          <input matInput placeholder="Hint" formControlName="hint">
      </mat-form-field>
    </div>

    <div class="pb-2">
      <button type="button" class="mat-raised-button" (click)="close()">Close</button>
      <button type="button" class="mat-raised-button mat-primary ml-2" (click)="validate(f.form); f.onSubmit($event)">Save</button>
    </div>
  </form>
</mat-dialog-content>
